import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/report/check-in';

const checkInAll = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/checkInActivitys`, data);
};

export default {
	checkInAll,
};
